<template>
    <router-link :to="href"
        class="img-loading">
        <img v-lazy="src" alt="">
    </router-link>
</template>

<script>
export default {
    props: {
        src: String,
        href: [ String, Object ]
    }
}
</script>

<style scoped>
/* 组件盒子 */
.img-loading{
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
}
.img-loading>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}
</style>
